"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.passwordRegex = exports.Regex = void 0;
/* eslint-disable */
exports.Regex = {
    ONLY_NUMBER: /(^[1-9]+)|([1-9]\d*)+$/,
    phoneNumbers: new RegExp("^[1-9][0-9]*$"),
    description: new RegExp(/^(.|\s)*[a-zA-Z]+(.|\s)*$/, "i"),
    email: new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
    password: new RegExp(/^(?=(.*[a-z]){1,})(?=(.*[A-Z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{8,25}$/),
    LINK_EMAIL: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/gi,
    LINK: /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&/=]*)/gi,
    DETECT_LINK: /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&/=]*)/gi,
    FIND_LINKS: /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&/=]*)|^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/gi,
    DETECT_LINKS_AND_EMAILS: /(^|[^a-zA-Z0-9._])([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}|[Ww][Ww][Ww]\.[a-zA-Z0-9._~:/?#[\]@!$&'()*+;=%-]+|https?:\/\/[a-zA-Z0-9._~:/?#[\]@!$&'()*+;=%-]+|[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\/[a-zA-Z0-9._~:/?#[\]@!$&'()*+;=%-]*)?)/gi,
    otp: /^\d{6}$/, // 6 digit otp
    ONLY_NUMBERS_UPTO_SIX_DIGITS: /^[0-9]{0,6}$/, // only allow numbers upto 6 digits for otp -> on change otp
};
exports.passwordRegex = {
    uppercase: /[A-Z]/, // 1 uppercase
    lowercase: /[a-z]/, // 1 lowercase
    number: /\d/, // 1 number
    noSpaces: /\s/, // No spaces -> need to be negated
    length: /^.{8,25}$/, // 8 to 25 characters
    special: /[!@#$%^&*()_+[\]{};':"\\|,.<>/?~]/, // 1 special character from the list ^ $ * . [ ] { } ( ) ? " ! @ # % & / \ , > < ' : ; | _ ~ ` = + -
    all: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z0-9\s])[A-Za-z\d^$*.{}()[\]\\?!"@#%&/,><':;|_~`=+-]{8,25}$/, // all criteria
};
